export default __webpack_public_path__ + "static/media/card-img.f9629bc1.png";